import request from '@/utils/request'

export function getHomeActivity() {
    return request({
        url: '/ich/activity/pc/home/activity',
        method: 'get',
    })
}
